import { useEffect } from 'react';
import {
  createHubSpotForm,
  OnFormReadyType,
  OnFormSubmittedType,
  OnFormSubmitType,
} from '../functions/hubspot/hubspot.service';

interface HubspotFormCreationProps {
  formId: string;
  formWrapperId: string;
  onFormReadyCallback: OnFormReadyType;
  onFormSubmitCallback?: OnFormSubmitType;
  onFormSubmittedCallback: OnFormSubmittedType;
  errorCallback?: () => void;
  dependencies?: any[];
  blockDependencies?: any[];
}

const useHubspotFormCreation = ({
  formId,
  formWrapperId,
  onFormReadyCallback,
  onFormSubmitCallback,
  onFormSubmittedCallback,
  errorCallback,
  dependencies = [],
  blockDependencies = [],
}: HubspotFormCreationProps): void => {
  useEffect(() => {
    if (!formId || !formWrapperId || blockDependencies.some((dependency) => dependency)) {
      return;
    }

    createHubSpotForm({
      formContainer: `#${formWrapperId}`,
      formId,
      onFormReadyCallback,
      onFormSubmitCallback,
      onFormSubmittedCallback,
      errorCallback,
    });
  }, dependencies);
};

export default useHubspotFormCreation;
